import React, { useMemo } from 'react';
import { Avatar, List, Button, PaperIcon } from '@nackle/paper';
import { getString } from '@nackle/intl-tools';
import { COURSE } from '../../const';

const CourseListItem = ({
  item,
  shape,
  size,
  buttonSize = 'middle',
  buttonShape = 'rectangle',
  showDescription = false,
  showCompleteIcon = true,
  showPlayIcon = false,
  showResumeIcon = false
}) => {
  /*
   * Size can be a int or a string but is allways passed as a string in props.
   * So we try to convert it to an int here, if it cannot covert we leave it 
   * as a string.
   */
  const avatarSize = useMemo(() => {
    const result = parseInt(size);
    return isNaN(result) ? size : result;
  }, [size]);
  const description = useMemo(() => {
    if (!showDescription) {
      return '';
    }

    const strippedString = item.description.replace(/(<([^>]+)>)/gi, '');

    if (strippedString.length > 100) {
      return strippedString.substring(0, 100) + '...';
    } else {
      return strippedString;
    }
  }, [item, showDescription]);

  const getButton = item => {
    let text = getString('button.start.label');
    let style = 'course-button button-start';
    let icon = showPlayIcon ? /*#__PURE__*/React.createElement(PaperIcon, {
      icon: "Play"
    }) : null;

    if (item.status === COURSE.COURSE_STATUS.IN_PROGRESS) {
      text = getString('button.resume.label');
      style = 'course-button button-resume';
      icon = showResumeIcon ? /*#__PURE__*/React.createElement(PaperIcon, {
        icon: "Clock3",
        collection: "linear"
      }) : null;
    } else if (item.status === COURSE.COURSE_STATUS.COMPLETED) {
      text = getString('button.complete.label');
      style = 'course-button button-complete';
      icon = showCompleteIcon ? /*#__PURE__*/React.createElement(PaperIcon, {
        className: "button-check",
        icon: "Check"
      }) : null;
    }

    return /*#__PURE__*/React.createElement(Button, {
      className: style,
      icon: icon,
      style: {
        minWidth: '100px'
      },
      size: buttonSize,
      shape: buttonShape,
      onClick: () => window.location = item.path
    }, text);
  };

  return /*#__PURE__*/React.createElement(List.Item, {
    className: "row",
    key: item.key,
    actions: [getButton(item)]
  }, /*#__PURE__*/React.createElement(List.Item.Meta, {
    avatar: /*#__PURE__*/React.createElement(Avatar, {
      className: "course-image",
      shape: shape,
      size: avatarSize,
      src: item.thumbnail.url
    }),
    title: item.title,
    description: showDescription ? description : null
  }));
};

export default CourseListItem;
//# sourceMappingURL=CourseListItem.js.map